import { lazy, Suspense } from 'react';

import { ErrorBoundaryWithRetry } from '@/_components';

import type { Props } from './use-add-number';

import { SingleLoader } from '../single-row-loader';
import type { PhoneNumberRef } from '../types';

const AddPhoneNumber = lazy(() => import('./add-phone-number'));

const AddPhoneNumberSuspense = function AddPhoneNumberSuspense({
  ref,
  ...props
}: Props & {
  ref?: React.Ref<PhoneNumberRef | null>;
}) {
  return (
    <ErrorBoundaryWithRetry>
      <Suspense fallback={<SingleLoader />}>
        <AddPhoneNumber {...props} ref={ref} />
      </Suspense>
    </ErrorBoundaryWithRetry>
  );
};

export { AddPhoneNumberSuspense };
